// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Actionsheet = createStyle({
  width: '$full',
  height: '$full',
  _web: {
    pointerEvents: 'none',
  },
});
